<template>
    <svg viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg">
        <rect width="6" :height="heightA" :transform="transformA"/>
        <rect width="6" height="18" transform="translate(7)"/>
        <rect width="6" :height="heightB" :transform="transformB"/>
    </svg>
</template>

<script>
import TweenLite from "gsap";

const viewBoxHeight = 18;
const animationLenght = 0.5;
const animationDelay = 0.15;

const aStartHeight = 13;
const aTargetHeight = 6;
const bStartHeight = 9;
const bTargetHeight = 14;

export default {
  name: "icon-analysis",
  props: {
    selected: Boolean
  },
  data() {
    return {
      heightA: aStartHeight,
      heightB: 9,
      transformA: this.makeTranslate(0, viewBoxHeight - aStartHeight),
      transformB: this.makeTranslate(14, viewBoxHeight - bStartHeight)
    };
  },
  watch: {
    selected: {
      immediate: true,
      handler: function() {
        this.setSelected(this.selected);
      }
    },
    heightA: {
      immediate: true,
      handler: function() {
        this.transformA = this.makeTranslate(0, viewBoxHeight - this.heightA);
      }
    },
    heightB: {
      immediate: true,
      handler: function() {
        this.transformB = this.makeTranslate(14, viewBoxHeight - this.heightB);
      }
    }
  },
  methods: {
    setSelected(selected) {
      if (selected) {
        this.tweenHeightA(aStartHeight, aTargetHeight);
        this.tweenHeightB(bStartHeight, bTargetHeight);
      } else {
        this.tweenHeightA(aTargetHeight, aStartHeight);
        this.tweenHeightB(bTargetHeight, bStartHeight);
      }
    },
    tweenHeightA(fromVal, toVal) {
      TweenLite.fromTo(
        this.$data,
        animationLenght,
        { heightA: fromVal },
        { 
          heightA: toVal,
          delay: animationDelay, 
        }
      );
    },
    tweenHeightB(fromVal, toVal) {
      TweenLite.fromTo(
        this.$data,
        animationLenght,
        { heightB: fromVal },
        { 
          heightB: toVal,
          delay: animationDelay, 
        }
      );
    },
    makeTranslate(x, y) {
      return "translate(" + x + " " + y + ")";
    }
  }
};
</script>